export default "__VITE_ASSET__43bfd98b__"